import { useSessionKey } from "@auth/sessionStore";
import { nodesByRoom } from "@capture/captureNodeStatus";
import { useCaptureNodes } from "@capture/captureQueries";
import { RoomCaptureControl } from "@capture/RoomCaptureControl";
import { useRoomsList } from "@rooms/roomsQueries";
import {
  EmptyNote,
  LabelTape,
  LedgerBody,
  LedgerCell,
  LedgerHead,
  LedgerHeadCell,
  LedgerRow,
  LedgerTable,
} from "@scribenote/brian-design-system";

export const RoomCaptureList = () => {
  const sessionKey = useSessionKey();
  // No polling on rooms: each room's desired revision rides the polled nodes.
  const { data: rooms } = useRoomsList(sessionKey, true);
  const { data: nodes } = useCaptureNodes(sessionKey);

  if (rooms.length === 0)
    return <EmptyNote>No rooms set up in this clinic yet.</EmptyNote>;

  const byRoom = nodesByRoom(nodes);
  const sorted = [...rooms].sort((a, b) => a.name.localeCompare(b.name));

  return (
    <LedgerTable>
      <LedgerHead>
        <tr>
          <LedgerHeadCell>Room</LedgerHeadCell>
          <LedgerHeadCell>Capture</LedgerHeadCell>
        </tr>
      </LedgerHead>
      <LedgerBody>
        {sorted.map((room) => (
          <LedgerRow key={room.id} data-testid={`room-capture-row-${room.id}`}>
            <LedgerCell>
              <LabelTape className="max-w-[12rem] truncate align-middle">
                {room.name}
              </LabelTape>
            </LedgerCell>
            <LedgerCell>
              <RoomCaptureControl
                roomUuid={room.id}
                roomName={room.name}
                nodes={byRoom.get(room.id) ?? []}
                desiredEnabled={room.captureEnabled}
                desiredRevision={room.captureRevision}
              />
            </LedgerCell>
          </LedgerRow>
        ))}
      </LedgerBody>
    </LedgerTable>
  );
};
